import {FC} from "react";
import IconZigzagAroow from "../../../../assets/icons/filters/icon-zigzag-arrow.svg";
import {ChartEntryButton} from "../GartnerCharts/ChartEntryButton";

interface IProps {
  openCharts: () => void;
}

export const MarketScienceCharts: FC<IProps> = ({openCharts}) => (
  <ChartEntryButton
    icon={IconZigzagAroow}
    label="Рыночные и научные метрики"
    onClick={openCharts}
  />
);
